import { compose, lifecycle } from 'recompose';

import { withFetch } from '../../app/entities/Entity/containers';
import withStaffingCompanyGroup from '../../app/containers/withStaffingCompanyGroup';
import { Endpoints } from '../../app/lib/LeanLinkService';
import requireProps from '../../app/lib/requireProps';

export default compose(
  withFetch(),
  lifecycle({
    componentWillMount() {
      const slug = window.location.hostname.split('.')[0];
      this.props.fetch({ url: Endpoints.public.staffingCompanyGroups({ slug }) })
        .then((data) => {
          this.setState({ staffingCompanyGroupId: data.result.id });
        });
    },
  }),
  requireProps(['staffingCompanyGroupId']),
  withStaffingCompanyGroup,
);
